/*----------- 返回 $_GET 对象, 仿PHP模式 -------*/
var $_GET = (function(){
    var url = window.document.location.href.toString();
    var u = url.split('?');
    if(typeof(u[1]) == 'string'){
        if(u[1].indexOf('#') != -1) {
            u = u[1].split('#');
            u = u[0].split('&');
        } else {
            u = u[1].split('&');
        }
        var get = {};
		for(var a = 0, b = u.length; a < b; a++){
            var j = u[a].split('=');
			if(j[0] && j[1]){
            	get[decodeURIComponent(j[0])] = decodeURIComponent(j[1]);
			}else if(j[0]){
				get[decodeURIComponent(j[0])] = '';
			}
        }
        return get;
    } else {
        return {};
    }
})();
(function() {
	/**
	 * 动态加载js文件
	 * @param  {string}   url      js文件的url地址
	 * @param  {Function} callback 加载完成后的回调函数
	 */
	var _getScript = function(url, callback) {
			var head = document.getElementsByTagName('head')[0],
					js = document.createElement('script');

			js.setAttribute('type', 'text/javascript'); 
			js.setAttribute('src', url); 

			head.appendChild(js);

			//执行回调
			var callbackFn = function(){
							if(typeof callback === 'function'){
									callback();
							}
					};

			if (document.all) { //IE
					js.onreadystatechange = function() {
							if (js.readyState == 'loaded' || js.readyState == 'complete') {
									callbackFn();
							}
					}
			} else {
					js.onload = function() {
							callbackFn();
					}
			}
	}

	//如果使用的是zepto，就添加扩展函数
	if(Zepto){
			$.getScript = _getScript;
	}
	
})();


//公共领券方法
/*
 * 注: 强依赖Zepto库
 * Zepto库: http://touch.m.dangdang.com/corejs/zepto.min.js
 * 页面结构(绑定click事件的对象)：<a href="javascript:void(0);" class="j_getCoupon" dd_name="点击领券" data-combination-type="0" data-actid="1507627442903"></a>
 * data-combination-type: 是否为精选礼券（可选）
 * data-actid: 活动ID（必须）
 * JS中的初始化：getCoupon.env = 1;//ajax请求的接口环境变量（用来区分开发环境：线上、st(2)、mtest(1)、杨骏的开发环境(3)、默认线上环境），或者直接写成接口path
 *				 getCoupon.yzm(obj);//调用加购方法，需要传入一个对象
 * obj可传参数：
 * obj.target: 点击的对象(包含data-combination-type和data-actid属性的对象)，可以是dom对象或是zepto对象（必须）
 * obj.type: 开启旋转验证(xz)、图形验证(tx)、短信验证(dx)，默认为旋转验证(xz)
 * obj.actionType: 调用接口的类型，默认是raffle_new，传h5是raffle_new_h5
 * obj.success: ajax成功时执行的函数
 * obj.error: ajax出错时执行的函数
 * obj.ajaxComplete: ajax操作完成时调用的函数
 * obj.ajaxBeforeSend: ajax操作前执行的函数
 * obj.ajaxError: ajax操作出错执行的函数
 * obj.getCouponSuccess: 领券成功函数
 * obj.buildIdentifyingCodeError: 获取验证码出错函数
 * obj.xzBeforeSend: 请求旋转验证码ajax操作前执行的函数
 * obj.xzSuccess: 请求旋转验证码ajax成功执行的函数
 * obj.xzError: 请求旋转验证码ajax出错执行的函数
 * obj.xzComplete: 请求旋转验证码ajax完成执行的函数
 * obj.tzBeforeSend: 请求图形验证码ajax操作前执行的函数
 * obj.tzSuccess: 请求图形验证码ajax成功执行的函数
 * obj.tzError: 请求图形验证码ajax出错执行的函数
 * obj.tzComplete: 请求图形验证码ajax完成执行的函数
 * obj.dxBeforeSend: 请求短信验证码ajax操作前执行的函数
 * obj.dxSuccess: 请求短信验证码ajax成功执行的函数
 * obj.dxError: 请求短信验证码ajax出错执行的函数
 * obj.dxComplete: 请求短信验证码ajax完成执行的函数
 * obj.dxTips: 短信验证码提示函数
 * obj.noBindMobile: 未绑定手机号码执行的函数
 * obj.noLogin: 未登录执行的函数
 * obj.identifyingCodeError： 验证码错误执行的函数
 * obj.pickCouponError: 领券出错执行的函数
 *
 * js例子：
 * 	//绑定领券功能
 * 	that.main.off('click', '.j_coupon_btn').on('click', '.j_coupon_btn', function(ev){
 *		ev.stopPropagation();
 *		ev.preventDefault();
 *		getCoupon.env = 3;
 *		getCoupon.actionType = 'h5';
		getCoupon.yzm({
			target: $(this),
			type: 'xz',
			noBindMobile: function(){
				pop.popup({type:"alert", text:"请到当当客户端绑定手机号", determine_name:"知道了", isInitMask:true});
			},
			noLogin: function(){
				window.location.href = login_url;
			},
			getCouponSuccess: function(data, btn){
				console.log(data);
				pop.popup({type:'pop', text:data ? data.errorMsg : '领券成功', determine_name:'知道了', isInitMask:true});
			},
			xzSuccess: function(data, status){
				console.log(data);
			},
			xzError: function(){
				pop.popup({type:"alert", text:'出错啦~请重试', determine_name:"知道了", isInitMask:true});
			},
			identifyingCodeError: function(data){
				pop.popup({type:'pop', text:data.errorMsg, isInitMask:true});
			},
			pickCouponError: function(data){
				setTimeout(function() {
					pop.popup({type:'pop', text:data ? data.errorMsg : '出错啦~请重试', speed:3000, isInitMask:true});
				}, 300);
			},
			dxError: function(data){
				pop.popup({type:'alert', text:data.errorMsg, determine_name:'知道了', isInitMask:true});
			},
			dxTips: function(data){
				pop.popup({type:'pop', text:data.errorMsg, isInitMask:true});
			},
			buildIdentifyingCodeError: function(text){
				//获取验证码出错
				pop.popup({type:'pop', text:text || '获取验证码出错', speed:3000, isInitMask:true});
			}
		});
 *	});
 */
if(typeof getCoupon === 'undefined'){
	var screenFontSize = $(window).width() < 640 ? 10 : 20,
		rem = $('html').css('font-size') ? screenFontSize / parseFloat($('html').css('font-size').replace('px', '')) : screenFontSize / 14,
		maskCss = '.yzm_mask{z-index:999;display:none;width:100%;height:100%;position:fixed;top:0;left:0;background-color:rgba(0,0,0,0.5);}',
		loadingCss = '.loading{position:fixed;top:0;left:0;width:100%;height:100%;-webkit-animation:monkey_ani .5s steps(1) infinite;background-image:url(http://img63.ddimg.cn/upload_img/00610/core/loading2.png);background-repeat:no-repeat;background-position:center center;background-size:2.325rem 2.325rem;z-index:999;display:none;}\
@-webkit-keyframes monkey_ani{\
    0%{background-image:url(http://img63.ddimg.cn/upload_img/00610/core/loading1.png);}\
    33%{background-image:url(http://img63.ddimg.cn/upload_img/00610/core/loading2.png);}\
    66%{background-image:url(http://img63.ddimg.cn/upload_img/00610/core/loading3.png);}\
    100%{background-image:url(http://img63.ddimg.cn/upload_img/00610/core/loading1.png);}\
}',
		identifyingCodeCss = 'html{position:relative;}\
			/*body.overflow{overflow:hidden;}*/\
			.yzm{display:none;width:100%;height:100%;position:fixed;top:0;left:0;z-index:999;}\
			.yzm .box{display:table;width:100%;height:100%;text-align:center;}\
			.yzm .box .cell{display:table-cell;vertical-align:middle;}\
			.yzm .box .cell .con{background-color:#ffffff;margin:0 ' + (.8 * rem) + 'rem;overflow:hidden;display:block;border-radius:' + (.25 * rem) + 'rem;}\
			.yzm .box .cell .con .title_con{display:block;background-color:#f6786a;height:' + (2.3 * rem) + 'rem;color:#ffffff;line-height:' + (2.3 * rem) + 'rem;position:relative;border-top-left-radius:' + (.25 * rem) + 'rem;border-top-right-radius:' + (.25 * rem) + 'rem;border-bottom:0 none;}\
			\
			.yzm .box .cell .con #xz.info{padding:' + (.7 * rem) + 'rem;display:none;word-break:break-all;}\
			.yzm .box .cell .con #xz.info i.word{display:block;float:left;text-align:left;color:#5a5a5a;font-size:' + (.7 * rem) + 'rem;}\
			.yzm .box .cell .con #xz.info b.change{display:block;float:right;color:#61a6ed;font-size:' + (.7 * rem) + 'rem;font-weight:normal;}\
			.yzm .box .cell .con #xz.info .yzm_con{display:block;padding-top:' + (.7 * rem) + 'rem;position:relative;text-align:left;overflow:hidden;width:100%;clear:both;}\
			.yzm .box .cell .con #xz.info .yzm_con .xz_yzm{display:block;margin:0 ' + (1 * rem) + 'rem;overflow:hidden;}\
			.yzm .box .cell .con #xz.info .yzm_con .xz_yzm .xz_pic_wrap{display:block;float:left;width:25%;position:relative;overflow:hidden;}\
			.yzm .box .cell .con #xz.info .yzm_con .xz_yzm .xz_pic_wrap img.placeholder_pic{display:block;width:100%;height:auto;}\
			.yzm .box .cell .con #xz.info .yzm_con .xz_yzm .xz_pic_wrap img.xz_pic{display:block;width:100%;height:100%;position:absolute;top:0;left:0;background-repeat:no-repeat;background-size:400%;}\
			.yzm .box .cell .con #xz.info .yzm_con .xz_yzm .xz_pic_wrap a{display:block;width:100%;height:100%;position:absolute;top:0;left:0;}\
			\
			.yzm .box .cell .con #tx.info{padding:' + (.7 * rem) + 'rem;display:none;word-break:break-all;}\
			.yzm .box .cell .con #tx.info i{display:block;text-align:left;color:#5a5a5a;font-size:' + (.7 * rem) + 'rem;}\
			.yzm .box .cell .con #tx.info .yzm_con{display:block;margin-top:' + (.5 * rem) + 'rem;position:relative;text-align:left;overflow:hidden;height:' + (2 * rem) + 'rem;width:100%;}\
			.yzm .box .cell .con #tx.info .yzm_con .input{display:block;padding-right:' + (3.525 * rem) + 'rem;width:100%;height:' + (1.75 * rem) + 'rem;margin-top:' + (.15 * rem) + 'rem;-webkit-box-sizing:border-box;box-sizing:border-box;border-radius:' + (.15 * rem) + 'rem;-webkit-border-radius:' + (.15 * rem) + 'rem;}\
			.yzm .box .cell .con #tx.info .yzm_con .input .clear{position:absolute;top:0;right:' + (3.425 * rem) + 'rem;width:' + (1.5 * rem) + 'rem;height:100%;display:none;}\
			.yzm .box .cell .con #tx.info .yzm_con .input .clear,.yzm .box .cell .con #dx.info .yzm_con .input .clear{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAMAAADzapwJAAAAQlBMVEUAAADW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbr6+v////29vbq6upBmLPPAAAAEXRSTlMATSTv/PSNzLeuMzDlyP6Oy+3hy9AAAACQSURBVBjTfZFZDsQgCEBRXGqr7WDt/a86EwyWTmLfh8uTEAR4Zwslu1zCpqVNO3X2ZIc1SDdoxDrSuO6tpyee8yz0z/KzK5/axVttvK0AR7+fldf+GgAKiR+WIkAm8U0sIcCorp2NBABU0fWO/oi9OL/kPsTqSiZ1T3456cmsg+y9jjVqOsMm+5xlRMIos/wC7cIWMOz8S8cAAAAASUVORK5CYII=) center center no-repeat;background-size:' + (.55 * rem) + 'rem;}\
			.yzm .box .cell .con #tx.info .yzm_con .input input{width:100%;height:100%;-webkit-box-sizing:border-box;box-sizing:border-box;padding:0 ' + (1.5 * rem) + 'rem 0 ' + (.4 * rem) + 'rem;border-radius:' + (.15 * rem) + 'rem;-webkit-border-radius:' + (.15 * rem) + 'remcolor:#323232;background-color:#f7f7f7;font-size:' + (.8 * rem) + 'rem;}\
			.yzm .box .cell .con #tx.info .yzm_con .img{display:block;position:absolute;right:0;top:0;width:' + (3.2 * rem) + 'rem;height:100%;background-color:#f1f1f1;border-radius:' + (.15 * rem) + 'rem;}\
			.yzm .box .cell .con #tx.info .yzm_con .img img{width:100%;height:100%;border-radius:' + (.15 * rem) + 'rem;display:block;}\
			.yzm .box .cell .con #tx.info .yzm_con .error{display:none;position:absolute;top:0;left:0;border-radius:' + (.15 * rem) + 'rem;background-color:#f7f7f7;color:#ff463c;font-size:' + (.65 * rem) + 'rem;line-height:' + (2.35 * rem) + 'rem;height:100%;text-indent:' + (.9 * rem) + 'rem;overflow:hidden;}\
			\
			.yzm .box .cell .con #dx.info{padding:' + (.7 * rem) + 'rem;display:none;word-break:break-all;}\
			.yzm .box .cell .con #dx.info i{display:block;text-align:left;color:#acacac;font-size:' + (.6 * rem) + 'rem;word-break:break-all;}\
			.yzm .box .cell .con #dx.info i del{color:#5a5a5a;}\
			.yzm .box .cell .con #dx.info .yzm_con{display:block;margin-top:' + (.5 * rem) + 'rem;position:relative;text-align:left;overflow:hidden;height:' + (1.75 * rem) + 'rem;width:100%;}\
			.yzm .box .cell .con #dx.info .yzm_con .input{display:block;padding-right:' + (3.525 * rem) + 'rem;width:100%;height:100%;-webkit-box-sizing:border-box;box-sizing:border-box;border-radius:' + (.15 * rem) + 'rem;-webkit-border-radius:' + (.15 * rem) + 'rem;position:relative;}\
			.yzm .box .cell .con #dx.info .yzm_con .input .clear{position:absolute;top:0;right:' + (3.525 * rem) + 'rem;width:' + (1.5 * rem) + 'rem;height:100%;display:none;}\
			.yzm .box .cell .con #dx.info .yzm_con .input input{width:100%;height:100%;-webkit-box-sizing:border-box;box-sizing:border-box;padding:0 ' + (1.5 * rem) + 'rem 0 ' + (.4 * rem) + 'rem;border-radius:' + (.15 * rem) + 'rem;-webkit-border-radius:' + (.15 * rem) + 'rem;color:#5a5a5a;background-color:#f7f7f7;font-size:' + (.8 * rem) + 'rem;}\
			.yzm .box .cell .con #dx.info .yzm_con .img{display:block;position:absolute;right:0;top:0;width:' + (3.2 * rem) + 'rem;height:100%;background-color:#f1f1f1;border-radius:' + (.15 * rem) + 'rem;-webkit-border-radius:' + (.15 * rem) + 'rem;}\
			.yzm .box .cell .con #dx.info .yzm_con .img img{width:100%;height:100%;border-radius:' + (.15 * rem) + 'rem;-webkit-border-radius:' + (.15 * rem) + 'rem;display:block;}\
			.yzm .box .cell .con #dx.info .yzm_con .repush{border:1px solid #f6786a;-webkit-box-sizing:border-box;box-sizing:border-box;height:100%;display:block;position:absolute;right:0;top:0;border-radius:' + (.15 * rem) + 'rem;-webkit-border-radius:' + (.15 * rem) + 'rem;text-align:center;font-size:' + (.6 * rem) + 'rem;color:#f6786a;background-color:#f7f7f7;width:' + (3.2 * rem) + 'rem;}\
			.yzm .box .cell .con #dx.info .yzm_con .repush.no{color:#acacac;border:1px solid #f7f7f7;}\
			.yzm .box .cell .con #dx.info .yzm_con .error{display:none;position:absolute;top:0;left:0;border-radius:' + (.15 * rem) + 'rem;-webkit-border-radius:' + (.15 * rem) + 'rem;background-color:#f7f7f7;color:#ff463c;font-size:' + (.8 * rem) + 'rem;line-height:' + (1.75 * rem) + 'rem;height:100%;text-indent:' + (.4 * rem) + 'rem;overflow:hidden;}\
			.yzm .box .cell .con .title{display:block;font-size:' + (.8 * rem) + 'rem;}\
			.yzm .box .cell .con .btn_con{display:block;border-top:1px solid #e0e0e0;}\
			.yzm .box .cell .con .btn{background-color:transparent;display:block;color:#aaaaaa;font-size:' + (.8 * rem) + 'rem;float:left;}\
			.yzm .box .cell .con .btn.determine,.yzm .box .cell .con .btn.cancel{width:50%;float:left;position:relative;}\
			.yzm .box .cell .con .btn.cancel:after{content:"";position:absolute;top:0;right:0;width:1px;height:100%;background-color:#e0e0e0;}\
			.yzm .box .cell .con .btn.determine{color:#ff463c;}\
			.yzm .box .cell .con .btn em{line-height:' + (2.25 * rem) + 'rem;display:block;}\
			.yzm .box .cell .con .btn.empty{background: none;padding-top: 0;margin-bottom: 0;}\
			.yzm .box .cell .con .btn.empty em{color:#c8c8c8;}',
		maskHtml = '<section class="yzm_mask"></section>',
		identifyingCodeHtml = '<section class="yzm" id="j_yzm">\
			<div class="box">\
				<p class="cell">\
					<span class="con">\
						<span class="title_con">\
							<span class="title">安全验证</span>\
						</span>\
						<span id="xz" class="info">\
							<i class="word">请点击图片至正确方向</i>\
							<b class="change" id="j_change">换一组</b>\
							<span class="yzm_con">\
								<span class="xz_yzm" id="j_xzYzm">\
									<span class="xz_pic_wrap j_xzPicWrap">\
										<img class="placeholder_pic" src="http://img60.ddimg.cn/upload_img/00610/core/emtpy_dot.png" alt="" />\
										<img class="xz_pic j_xzPic" src="http://img60.ddimg.cn/upload_img/00610/core/bg_pic.png" />\
										<a href="javascript:void(0);" class="j_rotateBtn"></a>\
									</span>\
									<span class="xz_pic_wrap j_xzPicWrap">\
										<img class="placeholder_pic" src="http://img60.ddimg.cn/upload_img/00610/core/emtpy_dot.png" alt="" />\
										<img class="xz_pic j_xzPic" src="http://img60.ddimg.cn/upload_img/00610/core/bg_pic.png" />\
										<a href="javascript:void(0);" class="j_rotateBtn"></a>\
									</span>\
									<span class="xz_pic_wrap j_xzPicWrap">\
										<img class="placeholder_pic" src="http://img60.ddimg.cn/upload_img/00610/core/emtpy_dot.png" alt="" />\
										<img class="xz_pic j_xzPic" src="http://img60.ddimg.cn/upload_img/00610/core/bg_pic.png" />\
										<a href="javascript:void(0);" class="j_rotateBtn"></a>\
									</span>\
									<span class="xz_pic_wrap j_xzPicWrap">\
										<img class="placeholder_pic" src="http://img60.ddimg.cn/upload_img/00610/core/emtpy_dot.png" alt="" />\
										<img class="xz_pic j_xzPic" src="http://img60.ddimg.cn/upload_img/00610/core/bg_pic.png" />\
										<a href="javascript:void(0);" class="j_rotateBtn"></a>\
									</span>\
								</span>\
							</span>\
						</span>\
						<span id="tx" class="info">\
							<i class="word">亲爱的用户，为了防止有人盗刷礼券损害您的权益，请输入下方验证码。</i>\
							<span class="yzm_con">\
								<span class="input">\
									<input type="text" placeholder="输入验证码" maxlength="10" />\
									<em class="clear"></em>\
								</span>\
								<span class="img"><img id="yzm_pic" src="" alt="" /></span>\
								<span class="error"></span>\
							</span>\
						</span>\
						<span id="dx" class="info">\
							<i class="word">为了确保礼券成功放入您的账户，领取礼券需要短信确认，验证码已发送至手机号：<del></del></i>\
							<span class="yzm_con">\
								<span class="input">\
									<input type="text" placeholder="输入验证码" maxlength="10" />\
									<em class="clear"></em>\
								</span>\
								<button class="repush no">60s</button>\
								<span class="error"></span>\
							</span>\
						</span>\
						<span class="btn_con">\
							<a href="javascript:void(0);" id="j_cancel" class="btn cancel" ontouchstart=""><em>取消</em></a>\
							<a href="javascript:void(0);" id="j_submit" class="btn empty determine" ontouchstart=""><em>确定</em></a>\
						</span>\
					</span>\
				</p>\
			</div>\
		</section>',
		loadingHtml = '<section class="loading"></section>',
		getCoupon = {
		    btn:null,
		    original : '', // 该文件 目前 h5专题 和老触屏一块使用，该字段用来标识使用该文件来源;h5:来源h5专题域；z:来源于z域；空 为touch老项目
			actionType: '', // 接口类型默认为空
			ajaxFlag: false, // ajax标志
			loadingTimeout: null, // loading延迟变量
			loadingObj: null, // loading对象
			// ajax请求默认事件
			action: 'raffle_new', // action名称
			success:function(res){},
			error:function(res){},
			ajaxComplete:function(status){
				if(!getCoupon.loadingTimeOut){
					getCoupon.loadingTimeout = setTimeout(function(){
						getCoupon.loadingObj && getCoupon.loadingObj.css('display', 'none');
					});
				}
			},
			ajaxBeforeSend:function(){
				if(getCoupon.loadingTimeOut){
					clearTimeout(getCoupon.loadingTimeout);
					getCoupon.loadingTimeout = null;
				}
				getCoupon.loadingObj && getCoupon.loadingObj.css('display', 'block');
			},
			ajaxError:function(err){
				if(!window.navigator.onLine){
					console.warn('无网络，请重试');
				}
				getCoupon.loadingObj && getCoupon.loadingObj.css('display', 'none');
			},
			
			init: function(){
				var that = this;
				var localHerf = window.location.href;
				if(localHerf.startsWith("https://")){
					that.domainArr = that.domainArr_h5;
				}
        // 将URL中的user_client、client_version、ucid、udid、union_id和permanent_id保存起来，调用coupon_center.php接口时传入
        var params = []
        if ($_GET['user_client']) {
          that.userClient = $_GET['user_client']
          params.push('user_client=' + that.userClient)
        }
        if ($_GET['client_version']) {
          that.clientVersion = $_GET['client_version']
          params.push('client_version=' + that.clientVersion)
        }
        if ($_GET['ucid']) {
          that.ucid = $_GET['ucid']
          params.push('ucid=' + that.ucid)
        }
        if ($_GET['udid']) {
          that.udid = $_GET['udid']
          params.push('udid='+ that.udid)
        }
        if ($_GET['union_id']) {
          that.unionId = $_GET['union_id']
          params.push('union_id=' + that.unionId)
        }
        if ($_GET['permanent_id']) {
          that.permanentId = $_GET['permanent_id']
          params.push('permanent_id=' + that.permanentId)
        }
        if (params && params.length) {
          that.ajaxUrl += (that.ajaxUrl.indexOf('?') >= 0 ? '' : '?') + params.join('&')
        }
				
				//引入滑块验证码组件
				var baseUrl = that.domainArr[0];				
				$.getScript(baseUrl + 'corejs/slidingVerify/slidingVerify.js',function(){});
				//蒙版
				if($('.yzm_mask').length <= 0){
					that.appendDom(maskCss, maskHtml);
				}
				//弹窗
				if($('#j_yzm').length <= 0){
					that.appendDom(identifyingCodeCss, identifyingCodeHtml);
				}
				//loading
				if($('.loading').length <= 0){
					that.appendDom(loadingCss, loadingHtml);
				}
				setTimeout(function(){
					that.body = $('body');
					that.loadingObj = $('.loading');
					that.con = $('#j_yzm');
					that.mask = $('.yzm_mask');
					that.xz = that.con.find("#xz");
					that.tx = that.con.find('#tx');
					that.dx = that.con.find('#dx');
					that.xzNum = that.xz.find('.j_xzPicWrap').length;
					that.submit = that.con.find('#j_submit');
				}, 300);
			},
			appendDom: function(style, dom){
				var styleObj = document.createElement('style');//样式
				styleObj.type = 'text/css';
				if(styleObj.styleSheet){
					styleObj.styleSheet.cssText = style;
				}else{
					styleObj.appendChild(document.createTextNode(style));
				}
				document.body.appendChild(styleObj);//将样式表加入页面底部
				$('body').append(dom);//将html加入页面底部
			},
			$ajax: function(obj){
				// 封闭ajax
				var that = this;
				if(!obj.url){
					return false;
				}
				// baseurl预留
				var baseUrl = that.domainArr[that.env],
					basePara = {};				
					basePara = {source: that.source};				
				//容错接口环境
				if(!isNaN(parseInt(that.env)) && (that.env >= that.domainArr.length || that.env < 0)){
					//环境变量小于0或者大于等于that.domainArr的长度，默认取正式领券环境
					that.env = 0;
					baseUrl = that.domainArr[that.env];
				}else if(!isNaN(parseInt(that.env)) && (that.env < that.domainArr.length && that.env >= 0)){
					//环境变量大于等于0或者小于that.domainArr的长度，取that.domainArr对应的领券环境
					baseUrl = that.domainArr[that.env];
				}else{
					//直接使用that.env变量作为领券环境path
					if(that.env){
						baseUrl = that.env;
					}else{
						that.env = 0;
						baseUrl = that.domainArr[that.env];
					}
				}
				// 封装请求 加上sid参数
				obj.data = $.extend(obj.data, basePara);
				//参数带sid
				//var sid = document.cookie.match(new RegExp("(^| )MDD_sid=([^;]*)(;|$)"));
				//if(sid != null){
				//	data.sid = decodeURIComponent(sid[2]);
				//}
				var ajaxRequest = $.ajax({
					url: baseUrl + obj.url,
					type: obj.type || 'post',
					data: obj.data,
					dataType: 'json',
					xhrFields: {withCredentials:true},//跨域携带cookie——jquery
					crossDomain: true,//跨域携带cookie——jquery
					beforeSend: function(xhr){
						try{
							xhr.withCredentials = true;//跨域携带cookie——zepto
						}catch(e){}
						that.ajaxFlag = true;
						that.ajaxBeforeSend();
						if(typeof obj.beforeSend === 'function'){
							obj.beforeSend();
						}
					},
					success: function(res, status){
						that.ajaxFlag = false;
						if(typeof obj.success === 'function'){
							obj.success(res, status);
						}
					},
					error: function(err){
						that.ajaxError(err);
						if(typeof obj.error === 'function'){
							obj.error(err);
						}
					},
					complete: function(status){
						that.ajaxFlag = false;
						that.ajaxComplete(status);
						if(typeof obj.complete === 'function'){
							obj.complete(status);
						}
					}
				});
				return ajaxRequest;
			},
      // 接口默认加传参数
      userClient: 'touch',
      clientVersion: '1.0',
      ucid: '',
      udid: '',
      unionId: '',
      permanentId: '',
			source: 2,//默认值2 旋转图形验证码 返回二进制流标识： 值：2时表示返回的是二进制流，其他：返回图片地址
			type: 'xz',//默认类型为旋转验证码
			body: null,//body对象
			con: null,//验证码对象
			mask: null,//验证码蒙版
			xzNum: 0,//旋转验证码个数
			xzH: 0,//旋转验证码区域高度
			xzW: 0,//旋转验证码区域宽度
			xzObj: null,//旋转功能对象
			xz: null,
			tx: null,
			dx: null,
			ajaxUrl: 'coupon_center.php',
			env: 0,//接口环境变量，默认线上环境接口
			domainArr: ['http://touch.m.dangdang.com/', 'http://mtest.dangdang.com/mtouch/', 'http://sttouch.m.dangdang.com/', 'http://yjtouch.m.dangdang.com/','http://touch_yhy.m.dangdang.com/'],
			domainArr_h5: ['https://mtouch.dangdang.com/', 'http://mtest.dangdang.com/mtouch/', 'http://sttouch.m.dangdang.com/', 'http://yjtouch.m.dangdang.com/','http://touch_yhy.m.dangdang.com/'],
			actid: 0,
			vcodeUrl: '',
			submit: null,
			countdown: 120,// 120s
			tempCount: 0,
			interval: null,
			repushBtn: null,
			repushDefText: "重新获取",
			repushFirstText: '获取验证码',
			shortMsgFlag: true,// 是否可能发送短信
			defaultType: 'hk',//默认调用方法
			getCouponSuccess: function(){},//领券成功
			xzBeforeSend: function(){},
			xzSuccess: function(data, status){},
			xzError: function(){},
			xzComplete: function(){},
			txBeforeSend: function(){},
			txSuccess: function(data, status){},
			txError: function(){},
			txComplete: function(){},
			dxBeforeSend: function(){},
			dxSuccess: function(data, status){},
			dxError: function(){},
			dxTips: function(){},
			dxComplete: function(){},
			noBindMobile: function(){},
			identifyingCodeError: function(){},
			buildIdentifyingCodeError: function(){},//获取验证码出错
			pickCouponError: function(){},
			cancleFun: function(){},//取消领券按钮
			verifyVer: 0,//领券验证码版本 ：0 旋转验吗； 1：滑块验证码； 默认为0
			yzm: function(obj){
				this.actid = obj.target.data('actid');//'1507719156479';
				if(!obj){
					console.error('缺少必要参数！');
					return false;
				}
				
				//领券事件
				if(typeof obj.getCouponSuccess === 'function'){
					this.getCouponSuccess = obj.getCouponSuccess;
				}
				//获取验证码出错
				if(typeof obj.buildIdentifyingCodeError === 'function'){
					this.buildIdentifyingCodeError = obj.buildIdentifyingCodeError;
				}
				//旋转事件
				if(typeof obj.xzBeforeSend === 'function'){
					this.xzBeforeSend = obj.xzBeforeSend;
				}
				if(typeof obj.xzSuccess === 'function'){
					this.xzSuccess = obj.xzSuccess;
				}
				if(typeof obj.xzError === 'function'){
					this.xzError = obj.xzError;
				}
				if(typeof obj.xzComplete === 'function'){
					this.xzComplete = obj.xzComplete;
				}
				//图形事件
				if(typeof obj.txBeforeSend === 'function'){
					this.txBeforeSend = obj.txBeforeSend;
				}
				if(typeof obj.txSuccess === 'function'){
					this.txSuccess = obj.txSuccess;
				}
				if(typeof obj.txError === 'function'){
					this.txError = obj.txError;
				}
				if(typeof obj.txComplete === 'function'){
					this.txComplete = obj.txComplete;
				}
				//短信事件
				if(typeof obj.dxBeforeSend === 'function'){
					this.dxBeforeSend = obj.dxBeforeSend;
				}
				if(typeof obj.dxSuccess === 'function'){
					this.dxSuccess = obj.dxSuccess;
				}
				if(typeof obj.dxError === 'function'){
					this.dxError = obj.dxError;
				}
				if(typeof obj.dxTips === 'function'){
					this.dxTips = obj.dxTips;
				}
				if(typeof obj.dxComplete === 'function'){
					this.dxComplete = obj.dxComplete;
				}
				//未绑定手机号码
				if(typeof obj.noBindMobile === 'function'){
					this.noBindMobile = obj.noBindMobile;
				}
				//未登录
				if(typeof obj.noLogin === 'function'){
					this.noLogin = obj.noLogin;
				}
				//验证码错误
				if(typeof obj.identifyingCodeError === 'function'){
					this.identifyingCodeError = obj.identifyingCodeError;
				}
				//领券出错
				if(typeof obj.pickCouponError === 'function'){
					this.pickCouponError = obj.pickCouponError;
				}
				//取消操作
				if(typeof obj.cancleFun === 'function'){
					this.cancleFun = obj.cancleFun;
				}
				//直接领券
				this.pickCoupon(obj.target, 'init');
			},
			//滑块验证码
			hkyzm:function(btn){
				var that = this;
				//初始化滑块验证码组件
				if($('.j_sliding_wrap').length==0){
					slidingYzm.init({
						hkCancelCallback: that.hkCancelCallback,
						hkRefreshCallback: that.hkRefreshCallback,
						hkSubmitCallback: that.hkSubmitCallback
					});
				}
				
				// 开启旋转验证码窗口
				//初始化数据
				that.btn = btn;
				that.tx.find('input').val('');
				that.dx.find('input').val('');
				that.shortMsgFlag = true;
				if(that.interval){
					clearInterval(that.interval);
					that.interval = null;
					that.repushBtn = dx.find('.repush');
					that.repushBtn.addClass('no').html(that.countdown + 's');
				}
				
				//获取滑块验证码
				that.getHkVerifyInfo('init');
				
			},
			//滑块验证码 取消回调
			hkCancelCallback: function(){
				var that = getCoupon;
				getCoupon.cancleFun();
			},
			//滑块验证码 刷新回调
			hkRefreshCallback: function(){
				// 开启旋转验证码窗口
				var that = getCoupon;
				that.shortMsgFlag = true;
				if(that.interval){
					clearInterval(that.interval);
					that.interval = null;
				}				
				// 获取滑块验证码
				that.getHkVerifyInfo();
			},
			// 滑块验证 滑到执行位置回调
			hkSubmitCallback: function(data){
				var that = getCoupon;
				that.pickCoupon(that.btn, 'hk', data);
			},
			// 获取滑块验证码
			getHkVerifyInfo: function(optType){
				var that = getCoupon;
				var btn = that.btn;
				// 判断状态
				var tempData = {action:that.action, activity_serial_num:that.actid, step:1,source_id: btn.data('sourceid')};//入参
				var combinationType= btn.data('combination-type');			
				if(combinationType || combinationType === 0 || combinationType === '0'){
					$.extend(tempData, {combinationType: combinationType});
				}
				if(that.verifyVer===1){
					$.extend(tempData, {is_hk_verify: 1});
					tempData.action = 'raffle_new_pic';
				}
				if(!that.ajaxFlag){
					that.$ajax({
						url: that.ajaxUrl,
						data: tempData,
						type: 'post',
						beforeSend: that.xzBeforeSend,
						success: function(data, status){
							if(data.errorCode == -10){
								// 未绑定手机号码
								that.con.css('display', 'none');
								that.mask.css('display', 'none');
								that.noBindMobile();
							}else if(data.errorCode == 96){
								//未登录,调用客户端登陆字典
								that.noLogin();
							}else if(data.errorCode == 0){
								// 弹出旋转验证码
								that.dx.find('del').html(data.mobile_num);
								// 展示 滑块验证码
								slidingYzm.getSlidingVerifyCode(data);
								that.con.css('display', 'none');
								that.mask.css('display', 'none');
								that.dx.css('display', 'none');
								that.tx.css('display', 'none');
								//只第一次获取验证码时需要执行该方法。刷新或者验证码错误之后从新获取改验证码时，不需要刷新
								if(optType==='init'){
									//验证
									that.xzSuccess(data, status);
								}
								
							}else{
								that.pickCouponError(data);
							}
						},
						error: function(){
							that.con.css('display', 'none');
							that.mask.css('display', 'none');
							that.xzError();
						},
						complete: that.xzComplete
					});
				}
				
			},
			xzPicCss: function(pic, url){
				//设置旋转图片背景图片
				for(var i = 0, j = pic.length; i < j; i++){
					if(url){
						$(pic[i]).attr('src', url);
					}
				}
			},
			xzyzm: function(btn){
				// 开启旋转验证码窗口
				var that = this,
					pic = that.xz.find('.j_xzPic');
				that.submit = that.con.find('#j_submit');
				that.submit.addClass('empty');
				that.tx.find('input').val('');
				that.dx.find('input').val('');
				that.shortMsgFlag = true;
				if(that.interval){
					clearInterval(that.interval);
					that.interval = null;
					that.repushBtn = dx.find('.repush');
					that.repushBtn.addClass('no').html(that.countdown + 's');
				}
				//绑定事件
				that.con.find(".cancel").off('click').on('click', function(){
					that.mask.css('display', 'none');
					that.con.css('display', 'none');
					//that.body.removeClass('overflow');
					that.xzPicCss(pic);
					that.cancleFun();
				});
				that.con.find('.determine').attr('status', 'xz').off('click').on('click', function(){
					//console.log($('#j_yzm #j_xzYzm').data('rotate_direction'));//旋转数据
					that.pickCoupon(btn, $(this).attr('status'));
				});
				that.xz.find('#j_change').off('click').on('click', function(){
					if(that.source === 2){
						that.xzyzmRefresh(btn);
					}else {
						//var ms = new Date();
						that.xzVerifyImg(pic, {vcode:that.vcodeUrl });
						that.xzObj.init();
					}
				});
				
				
				//判断状态
				var tempData = {action:that.action, activity_serial_num:that.actid, step:1,source_id: btn.data('sourceid')};//入参
								
				if(btn.data('combination-type') || btn.data('combination-type') === 0 || btn.data('combination-type') === '0'){
					$.extend(tempData, {combinationType:btn.data('combination-type')});
				}
				if(!that.ajaxFlag){
					that.$ajax({
						url: that.ajaxUrl,
						data: tempData,
						type: 'post',
						beforeSend: that.xzBeforeSend,
						success: function(data, status){
							if(data.errorCode == -10){
								// 未绑定手机号码
								that.con.css('display', 'none');
								that.mask.css('display', 'none');
								that.noBindMobile();
							}else if(data.errorCode == 96){
								//未登录,调用客户端登陆字典
								that.noLogin();
							}else if(data.errorCode == 0){
								// 弹出旋转验证码
								that.dx.find('del').html(data.mobile_num);
								
								that.getXzCaptcha(pic, that.con.find('.determine'), data);
								that.con.css('display', 'block');
								that.mask.css('display', 'block');
								that.dx.css('display', 'none');
								that.tx.css('display', 'none');
								that.xz.css('display', 'block');
								var picWrap = that.xz.find('.j_xzPicWrap');
								if(!that.xzH){
									that.xzH = picWrap.eq(that.xzNum - 1).height();
									that.xzW = picWrap.eq(that.xzNum - 1).width();
									//初始化旋转事件
									that.xzObj = new rotateYzm(that.xz.find('.j_rotateBtn'), $('#j_xzYzm'), '.j_xzPicWrap', '.j_xzPic');
									that.xzObj.direct.left = [];
									that.xzObj.direct.top = [];
									for(var i = 0; i < that.xzNum; i++){
										that.xzObj.direct.left.push('-' + (i * that.xzW) + 'px');
										that.xzObj.direct.top.push('-' + (i * that.xzH) + 'px');
										picWrap.eq(i).find('.j_xzPic').css({
											width:that.xzW * that.xzNum + 'px',
											height:that.xzH * that.xzNum + 'px'
										});
									}
									that.xzObj.init();
								}
								//that.body.addClass('overflow');
								that.xzSuccess(data, status);
							}
						},
						error: function(){
							that.con.css('display', 'none');
							that.mask.css('display', 'none');
							that.xzError();
						},
						complete: that.xzComplete
					});
				}
			},
			xzyzmRefresh: function(btn){
				// 开启旋转验证码窗口
				var that = this,
					pic = that.xz.find('.j_xzPic');
				that.shortMsgFlag = true;
				if(that.interval){
					clearInterval(that.interval);
					that.interval = null;
				}
				
				//判断状态
				var tempData = {action:that.action, activity_serial_num:that.actid, step:1};//入参
				
				if(btn.data('combination-type') || btn.data('combination-type') === 0 || btn.data('combination-type') === '0'){
					$.extend(tempData, {combinationType:btn.data('combination-type')});
				}
				if(!that.ajaxFlag){
					that.$ajax({
						url: that.ajaxUrl,
						data: tempData,
						type: 'post',
						beforeSend: that.xzBeforeSend,
						success: function(data, status){
							if(data.errorCode == -10){
								// 未绑定手机号码
								that.con.css('display', 'none');
								that.mask.css('display', 'none');
								that.noBindMobile();
							}else if(data.errorCode == 96){
								//未登录,调用客户端登陆字典
								that.noLogin();
							}else if(data.errorCode == 0){
								// 弹出旋转验证码								
								that.getXzCaptcha(pic, that.con.find('.determine'), data);
							}
						},
						error: function(){
							that.con.css('display', 'none');
							that.mask.css('display', 'none');
							that.xzError();
						},
						complete: that.xzComplete
					});
				}
			},
			txyzm: function(btn){
				// 开启图形验证码窗口
				var that = this,
					pic = that.tx.find('#yzm_pic'),
					err = that.tx.find('.error'),
					inp = that.tx.find('input');
				that.con.find('.clear').css('display', 'none');
				inp.val('');
				that.dx.find('input').val('');
				that.shortMsgFlag = true;
				if(that.interval){
					clearInterval(that.interval);
					that.interval = null;
					that.repushBtn = that.dx.find('.repush');
					that.repushBtn.addClass('no').html(that.countdown + 's');
				}
				//绑定事件
				that.con.find(".cancel").off('click').on('click', function(){
					that.mask.css('display', 'none');
					that.con.css('display', 'none');
					//that.body.removeClass("overflow");
					pic.attr("src", "");
				});
				that.con.find('.determine').attr("status", "tx").off('click').on('click', function(){
					if(!$.trim(inp.val())){
						//that.showError(err, "验证码错误，请重新输入");
					}else{
						that.pickCoupon(btn, $(this).attr("status"));
						pic.attr("src", "");
					}
				});
				inp.off("input propertychange").on("input propertychange", function(){
					var len = $(this).val().length;
					if(len > 0){
						$(this).closest(".input").find(".clear").css('display', 'block');
						that.submit.removeClass('empty');
					}else{
						$(this).closest(".input").find(".clear").css('display', 'none');
						that.submit.addClass('empty');
					}
				});
				that.tx.find(".clear").off('click').on('click', function(){
					$(this).css('display', 'none').closest(".input").find("input").val("");
					that.submit.addClass('empty');
				});
				that.tx.find(".img").off('click').on('click', function(){
					that.getTxCaptcha(pic, err, con.find('.determine'));
				});
				//判断状态
				var tempData = {action:that.action, activity_serial_num:that.actid, step:1,source_id: btn.data('sourceid')};
				
				if(btn.data('combination-type') || btn.data('combination-type') === 0 || btn.data('combination-type') === '0'){
					$.extend(tempData, {combinationType:btn.data('combination-type')});
				}
				if(!that.ajaxFlag){
					that.$ajax({
						url: that.ajaxUrl,
						data: tempData,
						type: 'post',
						beforeSend: that.txBeforeSend,
						success: function(data, status){
							if(data.errorCode == -10){
								// 未绑定手机号码
								that.con.css('display', 'none');
								that.mask.css('display', 'none');
								that.noBindMobile();
							}else if(data.errorCode == 96){
								//未登录,调用客户端登陆字典
								that.noLogin();
							}if(data.errorCode == 0){
								// 弹出图形验证码
								inp.val('');
								that.submit.addClass('empty');
								that.dx.find('del').html(data.mobile_num);
								
								that.getTxCaptcha(pic, err, that.con.find('.determine'), data);
								
								that.con.css('display', 'block');
								that.mask.css('display', 'block');
								that.dx.css('display', 'none');
								that.xz.css('display', 'none');
								that.tx.css('display', 'block');
								err.css({'display':'none', 'width':inp.width() + 'px'});
								//that.body.addClass("overflow");
								that.txSuccess(data, status);
							}
						},
						error: function(){
							that.con.css('display', 'none');
							that.mask.css('display', 'none');
							that.txError();
						},
						complete: that.txComplete
					});
				}
			},
			dxyzm: function(btn){
				// 开启短信验证码窗口
				var that = this,
					err = that.dx.find(".error"),
					inp = that.dx.find("input");
				that.con.find('.clear').css('display', 'none');
				that.submit.addClass('empty');
				inp.val('');
				that.repushBtn = that.dx.find('.repush');
				that.repushBtn.removeClass('no').html(that.repushFirstText);
				err.css({'display':'none', 'width': inp.width() + 'px'});
				//that.body.addClass("overflow");
				that.con.css('display', 'block');
				that.mask.css('display', 'block');
				that.xz.css('display', 'none');
				that.tx.css('display', 'none');
				that.dx.css('display', 'block');
				//绑定事件
				that.con.find('.determine').attr("status", "dx").off('click').on('click', function(){
					if(!$.trim(inp.val())){
						//that.showError(err, "请输入验证码");
					}else{
						that.pickCoupon(btn, $(this).attr("status"));
					}
				});
				that.dx.find("input").off("input propertychange").on("input propertychange", function(){
					var len = $(this).val().length;
					if(len > 0){
						$(this).closest(".input").find(".clear").css('display', 'block');
						that.submit.removeClass('empty');
					}else{
						$(this).closest(".input").find(".clear").css('display', 'none');
						that.submit.addClass('empty');
					}
				});
				that.dx.find(".clear").off('click').on('click', function(){
					$(this).css('display', 'none').closest(".input").find("input").val("");
					that.submit.addClass('empty');
				});
				that.dx.find(".repush").off('click').on('click', function(){
					if(/\bno\b/.test($(".repush").attr("class"))){
						return;
					}
					that.getDxCaptcha(btn);
				});
			},
			initTimes: function(){
				//初始化点击次数
				var that = this;
				//传值初始化
				that.con.find('#j_xzYzm').data('rotate_direction', '0,0,0,0');
				//单个旋转图片次数初始化
				that.xz.find('.j_rotateBtn').data('times', 0);
				//单个旋转图片显示位置初始化
				that.xz.find('.j_xzPic').css({
					top:0
				});
			},
			xzVerifyImg: function(pic, data){				
				// 生成旋转验证码
				var that = this;
				if(that.source === 2){
					that.xzVerifyImgBinary(pic, data);
				} else{
					that.xzVerifyImgUrl(pic, data);
				}			
			},
			//图片是以url方式输出
			xzVerifyImgUrl: function(pic, data){
				// 生成旋转验证码
				var that = this;
				that.initTimes();
				that.xzPicCss(pic);
				if(data.vcode){
					var ms = new Date(),
						img = new Image();
					img.onload = function(){
						that.xzPicCss(pic, img.src);
						that.submit.removeClass('empty');
					}
					img.src = data.vcode + "&t=" + ms.getTime();
					if(that.vcodeUrl != img.src){
						that.vcodeUrl = img.src;
					}
				}else{
					//that.showError(err, "获取验证码出错");
					that.buildIdentifyingCodeError();
				}
			},
			//图片是以二进制流方式输出
			xzVerifyImgBinary: function(pic, data){
				// 生成旋转验证码
				var that = this;
				that.initTimes();
				that.xzPicCss(pic);
				if(data.vcode){
					var ms = new Date(),
						img = new Image();
					img.onload = function(){
						that.xzPicCss(pic, img.src);
						that.submit.removeClass('empty');
					}
					img.src = 'data:image/jpg;base64,' + data.vcode ;
				}else{
					//that.showError(err, "获取验证码出错");
					that.buildIdentifyingCodeError();
				}
			},
			txVerifyImg: function(pic, err, data){
				// 生成图形验证码
				var that = this;
				pic.attr('src', '');
				if(data.vcode){
					var ms = new Date(),
						img = new Image();
					img.onload = function(){
						pic.attr("src", img.src);
					}
					img.src = data.vcode + "&v=" + ms.getTime();
				}else{
					//that.showError(err, "获取验证码出错");
					that.buildIdentifyingCodeError();
				}
			},
			getXzCaptcha: function(pic, btn, data){
				// 请求旋转验证码
				var that = this;
				that.submit.addClass('empty');
				var tempData = {action:that.action, activity_serial_num:that.actid, step:1,source_id: btn.data('sourceid')};
				
				if(btn.data('combination-type') || btn.data('combination-type') === 0 || btn.data('combination-type') === '0'){
					$.extend(tempData, {combinationType:btn.data('combination-type')});
				}
				if(!data){
					if(!that.ajaxFlag){
						that.$ajax({
							url: that.ajaxUrl,
							type: 'post',
							data: tempData,
							dataType: 'json',
							success: function(data, status){
								if(data.errorCode == -10){
									// 未绑定手机号码
									that.con.css('display', 'none');
									that.mask.css('display', 'none');
									that.noBindMobile();
								}else if(data.errorCode == 0){
									that.xzVerifyImg(pic, data);
								}
							},
							error: function(xhr, errorType, error){
								//that.com.css('display', 'none');
								//that.mask.css('display', 'none');
								that.buildIdentifyingCodeError();
							}
						});
					}else{
						//console.log('ajax正在执行');
					}
				}else{
					that.xzVerifyImg(pic, data);
				}
			},
			getTxCaptcha: function(pic, err, btn, data){
				// 请求图形验证码
				var that = this,
					inp = that.tx.find("input");
				inp.val('');
				that.submit.addClass('empty');
				that.con.find('.clear').css('display', 'none');
				var tempData = {action:that.action, activity_serial_num:that.actid, step:1,source_id: btn.data('sourceid')};
				
				if(btn.data('combination-type') || btn.data('combination-type') === 0 || btn.data('combination-type') === '0'){
					$.extend(tempData, {combinationType:btn.data('combination-type')});
				}
				if(!data && !that.ajaxFlag){
					that.$ajax({
						url: that.ajaxUrl,
						type: 'post',
						data: tempData,
						dataType: 'json',
						success: function(data, status){
							if(data.errorCode == -10){
								// 未绑定手机号码
								that.com.css('display', 'none');
								that.mask.css('display', 'none');
								that.noBindMobile();
							}else if(data.errorCode == 0){
								that.txVerifyImg(pic, err, data);
							}
						},
						error: function(xhr, errorType, error){
							//that.com.css('display', 'none');
							//that.mask.css('display', 'none');
							that.buildIdentifyingCodeError();
						}
					});
				}else{
					that.txVerifyImg(pic, err, data);
				}
			},
			getDxCaptcha: function(btn){
				// 请求短信验证码
				var that = this,
					err = that.dx.find(".error"),
					inp = that.dx.find("input");
				if(that.shortMsgFlag && !that.ajaxFlag){
					if(that.interval === null){
						that.tempCount = that.countdown;
						that.interval = setInterval(function(){
							if(that.tempCount <= 1){
								clearInterval(that.interval);
								that.interval = null;
								that.shortMsgFlag = true;
								that.repushBtn.removeClass("no").html(that.repushDefText);
								that.shortMsgFlag = true;
							}else{
								that.tempCount--;
								that.repushBtn.addClass("no").html(that.tempCount + 's');
							}
						}, 1000);
					}
					var tempData = {action:that.action, activity_serial_num:that.actid, step:3,source_id: btn.data('sourceid')};
					
					if(btn.data('combination-type') || btn.data('combination-type') === 0 || btn.data('combination-type') === '0'){
						$.extend(tempData, {combinationType:btn.data('combination-type')});
					}
					that.$ajax({
						url: that.ajaxUrl,
						type: 'post',
						data: tempData,
						dataType: 'json',
						success: function(data, status){
							if(data.errorCode == -10){
								// 未绑定手机号码
								that.com.css('display', 'none');
								that.mask.css('display', 'none');
								that.noBindMobile();
							}else if(data.errorCode == 96){
								//未登录,调用客户端登陆字典
								that.noLogin();
							}else if(data.errorCode == -1 || data.errorCode == -2 || data.errorCode == -7 || data.errorCode == -8){
								//that.showError($("#dx .error"), data.errorMsg);
								that.com.css('display', 'none');
								that.mask.css('display', 'none');
								that.dxTips(data);
							}else if(data.errorCode != 0){
								that.dxError(data);
							}else if(data.errorCode == 0){
								//that.con.css('display', 'none');
								//that.mask.css('display', 'none');
								//that.body.removeClass("overflow");
								// 短信计时
								that.shortMsgFlag = false;
								if(that.interval === null){
									that.tempCount = that.countdown;
									that.interval = setInterval(function(){
										if(that.tempCount <= 1){
											clearInterval(that.interval);
											that.interval = null;
											that.shortMsgFlag = true;
											that.repushBtn.removeClass("no").html(that.repushDefText);
											that.shortMsgFlag = true;
										}else{
											that.tempCount--;
											that.repushBtn.addClass("no").html(that.tempCount + 's');
										}
									}, 1000);
								}
							}else{
								that.con.css('display', 'none');
								that.mask.css('display', 'none');
								that.dxError(data);
							}
						},
						error: function(xhr, errorType, error){
							//that.com.css('display', 'none');
							//that.mask.css('display', 'none');
							that.buildIdentifyingCodeError('数据出错');
						}
					});
				}
			},
			showError: function(err, text){
				// 显示验证码错误
				var that = this;
				err.html(text).css('display', 'block');
				that.con.find('input').val('');
				that.con.find('.clear').css('display', 'none');
				setTimeout(function(){
					err.css('display', 'none');
				}, 3000);
			},
			pickCoupon: function(btn, status, hkparam){
				// 领券
				if(this.actionType.toLowerCase() === 'h5'){
					this.action = 'raffle_new_h5';
				}
				var that = this,
					obj = {
						action: that.action,
						activity_serial_num: btn.data('actid'),
						source_id: btn.data('sourceid'),
					},
					err = null;
				if(btn.data('combination-type') || btn.data('combination-type') === 0 || btn.data('combination-type') === '0'){
					$.extend(obj, {combination_type:btn.data('combination-type')});
				}
				
				if(that.verifyVer===1){
					$.extend(obj, {is_hk_verify: 1, stuation:1});
				}
				if(!that.ajaxFlag){
					if(status == 'init'){
						//obj.verify_code = '';
						obj.step = 2;
						
						that.$ajax({
							url: that.ajaxUrl,
							type: 'post',
							data: obj,
							beforeSend: function(){},
							success: function(data, status){
								btn.ajaxFlag = false;
								if(data.errorCode == 96){
									//未登录,调用客户端登陆字典
									that.noLogin();
								}else if(data.errorCode == 403){
									// 黄牛 调用短信验证
									that.dxyzm(btn);
								}else if(data.errorCode == 0 || data.errorCode == 500 || (that.original === 'h5' && (data.errorCode == 204 || data.errorCode == 203 || data.errorCode == 600))){
									//领券成功
									that.getCouponSuccess(data, btn);
								}else if(data.errorCode == 10001){
									if(data.is_hd && data.is_hd===1 ){
										that.type = 'hk';
										that.verifyVer = 1;
									}
									//需要弹验证码
									if(that.type){
										that[that.type + 'yzm'] && that[that.type + 'yzm'](btn);
									}else{
										that[that.defaultType + 'yzm'](btn);
									}
								}else{
									that.pickCouponError(data);
								}
								if (data.errorCode != 402 && data.errorCode != 403) {
									that.con.css('display', 'none');
									that.mask.css('display', 'none');
									//that.body.removeClass("overflow");
								}
							},
							complete: function(){},
							error: function(xhr, errorType, error) {
								that.con.css('display', 'none');
									that.mask.css('display', 'none');
								that.pickCouponError();
							}
						});
					}else if(status == 'xz'){
						// 旋转
						obj.verify_code = $.trim(that.con.find('#j_xzYzm').data('rotate_direction'));
						obj.step = 2;
						
						that.$ajax({
							url: that.ajaxUrl,
							type: 'post',
							data: obj,
							beforeSend: function(){},
							success: function(data, status){
								if(data.errorCode == 96){
									//未登录,调用客户端登陆字典
									that.noLogin();
								}else if(data.errorCode == 402 || data.errorCode == 407){
									// 验证码错误
									that.identifyingCodeError(data);
									that.getXzCaptcha(that.xz.find('.j_xzPic'), btn);
								}else if(data.errorCode == 403){
									// 黄牛 调用短信验证
									that.dxyzm(btn);
								}else if(data.errorCode == 0 || data.errorCode == 500 || (that.original === 'h5' && (data.errorCode == 204 || data.errorCode == 203 || data.errorCode == 600))){
									//领券成功
									that.getCouponSuccess(data, btn);
								}else{
									that.pickCouponError(data);
								}
								if(data.errorCode != 402 && data.errorCode != 407 && data.errorCode != 403){
									that.con.css('display', 'none');
									that.mask.css('display', 'none');
									//that.body.removeClass("overflow");
								}
							},
							complete: function(){},
							error: function(xhr, errorType, error){
								that.con.css('display', 'none');
								that.mask.css('display', 'none');
								that.pickCouponError();
							}
						});
					}else if(status == "tx"){
						// 图形
						err = that.tx.find(".error");
						obj.verify_code = $.trim(that.tx.find('input').val());
						obj.step = 2;
						
						that.$ajax({
							url: that.ajaxUrl,
							type: 'post',
							data: obj,
							dataType: 'json',
							success: function(data, status){
								if(data.errorCode == 96){
									//未登录,调用客户端登陆字典
									that.noLogin();
								}else if(data.errorCode == 402){
									// 验证码错误
									//that.showError(err, data.errorMsg);
									that.identifyingCodeError(data);
									that.getTxCaptcha(that.tx.find("#yzm_pic"), err, btn);
								}else if(data.errorCode == 403){
									// 黄牛 调用短信验证
									that.dxyzm(btn);
								}else if(data.errorCode == 0 || data.errorCode == 500 || (that.original === 'h5' && (data.errorCode == 204 || data.errorCode == 203 || data.errorCode == 600))){
									//领券成功
									that.getCouponSuccess(data, btn);
								}
								if(data.errorCode != 402 && data.errorCode != 403){
									that.con.css('display', 'none');
									that.mask.css('display', 'none');
									//that.body.removeClass("overflow");
								}
							},
							error: function(xhr, errorType, error) {
								that.con.css('display', 'none');
								that.mask.css('display', 'none');
								that.pickCouponError();
							}
						});
					}else if(status == "hk"){
						that = getCoupon;
						$.extend(obj, hkparam);
						obj.step = 2;
						
						that.$ajax({
							url: that.ajaxUrl,
							type: 'post',
							data: obj,
							beforeSend: function(){},
							success: function(data, status){
								if(data.errorCode == 96){
									//未登录,调用客户端登陆字典
									that.noLogin();
								}else if(data.errorCode == 410 || data.errorCode == 411 || data.errorCode == 412){
									// 验证码错误
									slidingYzm.activityFail(data);
									that.hkRefreshCallback();
								}else if(data.errorCode == 403){
									// 黄牛 调用短信验证
									that.dxyzm(btn);
								}else if(data.errorCode == 0 || data.errorCode == 500 || (that.original === 'h5' && (data.errorCode == 204 || data.errorCode == 203 || data.errorCode == 600))){
									//领券成功
									that.getCouponSuccess(data, btn);
									slidingYzm.activitySuccess(data);
								}else{
									that.pickCouponError(data);
								}
								if(data.errorCode != 402 && data.errorCode != 407 && data.errorCode != 403 && data.errorCode != 410 && data.errorCode != 411 && data.errorCode != 412){
									$('.j_slide_success_text').hide();
									$('.j_sliding_wrap').hide();
									//that.body.removeClass("overflow");
								}
							},
							complete: function(){},
							error: function(xhr, errorType, error){
								that.con.css('display', 'none');
								that.mask.css('display', 'none');
								that.pickCouponError();
							}
						});
					}else{
						// 短信
						err = that.dx.find('.error');
						obj.sms_code = $.trim(that.dx.find('input').val());
						obj.step = 4;
					
						that.$ajax({
							url: that.ajaxUrl,
							type: 'post',
							data: obj,
							dataType: 'json',
							success: function(data, status) {
								if (data.errorCode == 96) {
									//未登录,调用客户端登陆字典
									that.noLogin();
								} else if (data.errorCode == 404) {
									//that.showError(err, data.errorMsg);
									that.dxTips(data);
								}else if(data.errorCode == 0 || data.errorCode == 500 || (that.original === 'h5' && (data.errorCode == 204 || data.errorCode == 203 || data.errorCode == 600))){
									//领券成功
									that.getCouponSuccess(data, btn);
								}
								if (data.errorCode != 404) {
									that.con.css('display', 'none');
									that.mask.css('display', 'none');
									//that.body.removeClass("overflow");
								}
							},
							error: function(xhr, errorType, error) {
								that.con.css('display', 'none');
									that.mask.css('display', 'none');
								that.pickCouponError();
							}
						});
					}
				}
			},
		};
	//旋转图片验证码
	var rotateYzm = function(obj, dataObj, wrap, filter){
		if(!obj){
			return;
		}
		this.direct = {
			left: [],
			top: []
		};
		this.rotateBtn = obj;
		this.wrap = wrap;
		this.filter = filter;
		this.pos = [];
		this.rotateWrapObj = dataObj;
		this.init();
	};
	rotateYzm.prototype.constructor = rotateYzm;
	rotateYzm.prototype.init = function(){
		//初始化
		this.pos = [];
		for(var i = 0, j = this.rotateBtn.length; i < j; i++){
			var wrap = $(this.rotateBtn[i]).closest(this.wrap),
				left = wrap.index();
			$(this.rotateBtn[i]).siblings(this.filter).css({
				left:this.direct.left[left],
				top:this.direct.top[0]
			});
			//初始化旋转次数
			$(this.rotateBtn[i]).data('times', 0);
			this.pos.push(0);
		}
		//初始化旋转图片方向数据
		this.rotateWrapObj.data('rotate_direction', this.pos.toString());
		this.bindEvent();
	};
	rotateYzm.prototype.bindEvent = function(){
		//绑定事件
		var that = this;
		that.rotateBtn.off('click').on('click', function(ev){that.rotate(ev, this);});
	};
	rotateYzm.prototype.rotate = function(ev, obj){
		ev.stopPropagation();
		ev.preventDefault();
		//旋转
		var that = this,
			$this = $(obj),
			wrap = $this.closest(this.wrap),
			pic = $this.siblings(this.filter),
			times = $this.data('times') || 0,
			deg = '',
			left = wrap.index();
		times++;
		pic.css({
			left:that.direct.left[left],
			top:that.direct.top[times % 4]
		});
		$this.data('times', times);
		if(that.rotateWrapObj.data('rotate_direction')){
			that.pos = that.rotateWrapObj.data('rotate_direction').split(',');
			that.pos = that.pos.map(function(val, ind, arr){
				return parseInt(val);
			});
		}else{
			that.pos = [];
			for(var i = 0, j = this.rotateBtn.length; i < j; i++){
				that.pos.push(0);
			}
		}
		that.pos[$this.closest(this.wrap).index()] = times % 4;
		//that.pos[$this.closest(this.wrap).index()] = times;
		that.rotateWrapObj.data('rotate_direction', that.pos.toString());
	};
	getCoupon.init();//初始化
}

window.getCoupon=getCoupon
